<template>
  <div>
    <PartnerHeader :img_header="header_image" header="แก้ไขโปรโมชั่นราคาใหม่" link_back="promotioninformation"/>
    <MenuPartner/>
    <Promotion_edit_pos_price/>
  </div>
</template>

<script>
import PartnerHeader from "@/components/admin/manage_pos/partner_store_setting/menu_partner_store/PartnerHeader";
import HeaderImage from "@/assets/process.png";
// import MenuPartner from "@/components/admin/manage_pos/partner_store_setting/menu_partner_store/MenuPartner";
import Promotion_edit_pos_price from "@/components/admin/manage_pos/partner_store_setting/Promotion_edit_pos_price";
export default {
  name: "PromotionEditPosPrice",
  components: {
    Promotion_edit_pos_price,
    // MenuPartner,
    PartnerHeader
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
